import { AbsoluteCenter } from '@chakra-ui/react';

import { Typography } from 'shared';

type ScheduledMessageEmptyStateProps = {
  hasItems: boolean;
  children: React.ReactNode;
};

export const ScheduledMessageEmptyState = ({
  hasItems,
  children,
}: ScheduledMessageEmptyStateProps) =>
  hasItems ? (
    <>{children}</>
  ) : (
    <AbsoluteCenter>
      <Typography color="gray">Not scheduled messages...</Typography>
    </AbsoluteCenter>
  );
